import React from 'react';
import SettingsPersonalInfo from './SettingsPersonalInfo';
import SettingsProfessional from './SettingsProfessional';
import SettingsSecurity from './SettingsSecurity';

const SettingsContent = ({
  activeTab,
  isEditing,
  setIsEditing,
  profileImage,
  setProfileImage,
  profileResponse,
  setProfileImagePreview,
  isSaving,
  isUpdating,
  handleSave,
  isChangingPassword,
  isPasswordChanging,
  handlePasswordChange,
  profileData,
  handleInputChange,
  newExpertise,
  setNewExpertise,
  handleExpertiseAdd,
  handleExpertiseRemove,
  handleExpertiseKeyPress
}) => {
  const tabs = [
    { id: 'personal', name: 'Personal Info', icon: '👤' },
    { id: 'professional', name: 'Professional', icon: '💼' },
    { id: 'security', name: 'Security', icon: '🔒' }
  ];

  return (
    <div className="flex-1 p-8">
      {/* Edit/Save Buttons */}
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 capitalize transform transition-all duration-500">
          {tabs.find(tab => tab.id === activeTab)?.name}
        </h2>
        <div className="flex space-x-3">
          {activeTab === 'security' ? (
            <button
              onClick={handlePasswordChange}
              disabled={isChangingPassword || isPasswordChanging}
              className="px-6 py-3 bg-green-500 text-white rounded-2xl font-semibold transition-all duration-300 ease-out hover:bg-green-600 hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
            >
              {(isChangingPassword || isPasswordChanging) ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Changing Password...</span>
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  <span>Change Password</span>
                </>
              )}
            </button>
          ) : isEditing ? (
            <>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setProfileImage(null);
                  setProfileImagePreview(profileResponse?.data?.image || '');
                }}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-2xl font-semibold transition-all duration-300 ease-out hover:bg-gray-50 hover:scale-105 hover:shadow-lg"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={isSaving || isUpdating}
                className="px-6 py-3 bg-green-500 text-white rounded-2xl font-semibold transition-all duration-300 ease-out hover:bg-green-600 hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
              >
                {(isSaving || isUpdating) ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Save Changes</span>
                  </>
                )}
              </button>
            </>
          ) : (
            <button
              onClick={() => setIsEditing(true)}
              className="px-6 py-3 bg-green-500 text-white rounded-2xl font-semibold transition-all duration-300 ease-out hover:bg-green-600 hover:scale-105 hover:shadow-lg flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              <span>Edit Profile</span>
            </button>
          )}
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'personal' && (
        <SettingsPersonalInfo
          profileData={profileData}
          handleInputChange={handleInputChange}
          isEditing={isEditing}
        />
      )}

      {activeTab === 'professional' && (
        <SettingsProfessional
          profileData={profileData}
          handleInputChange={handleInputChange}
          isEditing={isEditing}
          newExpertise={newExpertise}
          setNewExpertise={setNewExpertise}
          handleExpertiseAdd={handleExpertiseAdd}
          handleExpertiseRemove={handleExpertiseRemove}
          handleExpertiseKeyPress={handleExpertiseKeyPress}
        />
      )}

      {activeTab === 'security' && (
        <SettingsSecurity
          profileData={profileData}
          handleInputChange={handleInputChange}
        />
      )}
    </div>
  );
};

export default SettingsContent;